import { ReviewSortEnum } from '@iheartjane/dm-sdk';
import { z } from 'zod';

export const UpvotePayloadSchema = z.object({
  page: z.coerce.number().int().min(1),
  productId: z.coerce.number().int().min(1),
  reviewId: z.string(),
  sortOrder: z.nativeEnum(ReviewSortEnum),
});
export enum ReviewIntent {
  Report = 'report',
  Upvote = 'upvote',
}
